/**
 * Table of time ranges (in seconds) and their corresponding bucket sizes (also in seconds).
 * Each entry: [maximum range in seconds, bucket size in seconds]
 */
const BUCKET_RULES: Array<[number, number]> = [
  [5 * 60, 1], // up to 5 minutes  → 1s
  [30 * 60, 5], // up to 30 minutes → 5s
  [60 * 60, 10], // up to 1 hour     → 10s
  [6 * 60 * 60, 30], // up to 6 hours    → 30s
  [12 * 60 * 60, 60], // up to 12 hours   → 1m
  [24 * 60 * 60, 300], // up to 1 day      → 5m
  [7 * 24 * 60 * 60, 900], // up to 7 days     → 15m
  [30 * 24 * 60 * 60, 3600], // up to 30 days    → 1h
  [90 * 24 * 60 * 60, 10800], // up to 90 days    → 3h
  [365 * 24 * 60 * 60, 86400], // up to 1 year     → 1d
];

/** Default bucket size (in seconds) if the time range exceeds all defined rules */
const DEFAULT_BUCKET_SIZE = 86400; // 1 day

/**
 * Returns the optimal bucket size (in seconds) based on the total time range.
 *
 * @param start - Start time (ISO string, timestamp, or Date)
 * @param end - End time (ISO string, timestamp, or Date)
 * @returns Optimal bucket size in seconds
 */
export function getOptimalBucketSize(start: string, end: string): number {
  const startMs = new Date(start).getTime();
  const endMs = new Date(end).getTime();

  const diffSeconds = Math.max(1, Math.floor((endMs - startMs) / 1000));

  for (const [maxRange, bucket] of BUCKET_RULES) {
    if (diffSeconds <= maxRange) return bucket;
  }

  return DEFAULT_BUCKET_SIZE;
}
